// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"e0b7a8c8","338":"10de7180","484":"139a14c0","787":"6fb4490e"}[chunkId] + ".chunk.js";
};